module.exports = ".main-wrapper {\n    overflow:hidden !important;\n}"